<template>
	<div class="row">
		<div class="col-md-12" v-if="isDeveloper">
			<div class="col-md-3">
				<h3>Debug Flags</h3>
				<input type="text"
							 name="flagSearch"
							 class="form-control"
							 placeholder="Search for debug flags"
							 v-model="flagSearchQuery" />
				<div class="flags-wrap">
					<div :key="key" v-for="(flag, key) in filteredFlags">
						<label>
							<toggle-button
								:cssColors="true"
								:name="key"
								:value="flag.isActive"
								@input="setFlag(key, flag.isActive)"
							/>
							<span>{{flag.title}}</span>
						</label>
						<p>
							<i>{{flag.description}}</i>
						</p>
						<hr/>
					</div>
					<div v-if="filteredFlagsIsEmpty" class="text-center">
						<p>
							No flags found for <b><i>'{{flagSearchQuery}}'</i></b>
						</p>
					</div>
				</div>
			</div>
			<div class="col-md-9">
				<h3>Access Token</h3>
				<textarea class="form-control token-text" v-model="token"></textarea>
			</div>
		</div>

		<div v-else class="col-md-12">
			<div class="col-md-6 col-md-offset-3">
				<div class="alert alert-warning" role="alert">Sorry, you do not have permission to access this screen</div>
			</div>
		</div>
	</div>
</template>

<script>
	import SapphireToggle from "COMMONS/SapphireToggle/SapphireToggle.vue";

	export default {
		created(){
			this.$store.commit('pageTitle', 'Debug Flags');
		},
		computed: {
			token:{
				get: function() {
					return this.$store.state.accessToken;
				},
				set: function(v) {
					this.$store.commit('updateAccessToken', {access_token:v});
				}
			},
			isDeveloper() {
				// Any one can go to this page we aren't checking if they are developer.
				return true //this.$store.state.isDeveloper;
			},
			flags() {
				return this.$store.state.debug.flags;
			},
			filteredFlagsIsEmpty(){
				return Object.keys(this.filteredFlags).length === 0
			},
			filteredFlags() {
				var result = {}, key;
				for (key in this.flags) {
					var isMatch = String(this.flags[key].title).indexOf(this.flagSearchQuery) > -1;
					if( isMatch ) {
						result[key] = this.flags[key];
					}
				}

				return result;
			}
		},
		data() {
			return {
				flagSearchQuery: "",
			};
		},
		methods: {
			setFlag(key){
				console.log('set')
				this.$store.commit('setFlag', {flag:key, isActive:!this.flags[key].isActive})
			}
		},
		created(){
			this.$store.commit('updatePageTitle', 'Debug Flags');
		},
		components: {
			"toggle-button": SapphireToggle
		}
	}
</script>

<style scoped>
	.flags-wrap {
		margin-top: 25px;
		overflow-y: scroll;
		height: 500px;
	}

	.flags-wrap span {
		margin-left: 15px;
		position: relative;
		top: -2px;
	}

	.token-text {
		resize: none;
		height: 75px;
	}
</style>
